import Rest from './rest';

const RESOURCE = "profile";

export default {

    getProfile: function () {
        return Rest.get(RESOURCE);
    },
    updateProfile: function (data) {
        return Rest.put(RESOURCE, data);
    }
};



// WEBPACK FOOTER //
// ./src/services/ProfileService.js